import type { NotificationItem } from "@crewledger/shared/schemas";
import { apiFetch } from "@/lib/api";

export async function fetchNotifications(params?: {
  page?: number;
  pageSize?: number;
  unreadOnly?: boolean;
}) {
  const search = new URLSearchParams();
  if (params?.page) search.set("page", String(params.page));
  if (params?.pageSize) search.set("pageSize", String(params.pageSize));
  if (params?.unreadOnly) search.set("unreadOnly", "true");
  const qs = search.toString();
  return apiFetch<{ data: NotificationItem[]; meta: { total?: number } }>(
    `/api/notifications${qs ? `?${qs}` : ""}`,
  );
}

export async function fetchUnreadCount() {
  return apiFetch<{ data: { count: number } }>("/api/notifications/unread-count");
}

export async function markNotificationRead(notificationId: string) {
  return apiFetch<{ data: NotificationItem }>(`/api/notifications/${notificationId}/read`, {
    method: "PATCH",
  });
}

export async function markAllNotificationsRead() {
  return apiFetch<{ data: { updated: number } }>("/api/notifications/mark-all-read", {
    method: "POST",
  });
}
